import { Component, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DetectionLimitExhaustModalComponent } from '../detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay'
import { FeedbackModalComponent } from 'src/app/Components/feedback-modal/feedback-modal.component';
import { isPlatformBrowser } from '@angular/common';

declare var $: any;
import * as $ from 'jquery';

@Component({
  selector: 'app-english-grammar-checker',
  templateUrl: './english-grammar-checker.component.html',
  styleUrls: ['./english-grammar-checker.component.scss']
})
export class EnglishGrammarCheckerComponent implements OnInit {
  public minLength = 0;
  public maxLength = 300;
  private isMobile: boolean = false;
  
  editorConfig: any = {
    endpoint: environment.server_url.multilingual_server,
    lang: 'en',
    minHeight: 360,
    sessionLimit: 3,
  };
  constructor(
    private _snackBar: MatSnackBar,
    private _dialog: MatDialog,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (window.matchMedia("(max-width: 767px)").matches) {
        // Code for screens below 767px
        $('.left-side .card-footer button').click(function(){
          $('.left-side .editor-wrapper').css({
            'min-height': '120px',
            'max-height': '120px'
          });
          $('.left-side .form-group').css({
            'min-height': '120px'
          });
          $('.left-side').addClass('resultAdjust');
        });
      
        $(".left-side .editor-wrapper").on("click", function() {
          $('.left-side .editor-wrapper').css({
            'min-height': '200px',
            'max-height': '280px'
          });
          $('.left-side.resultAdjust .form-group').css({
            'min-height': '200px'
          });
          $('.left-side').removeClass('resultAdjust');
        });

        $(".right-side .editor-wrapper").on("click", function() {
          $('.left-side .editor-wrapper').css({
            'min-height': '120px',
            'max-height': '120px'
          });
          $('.left-side .form-group').css({
            'min-height': '120px'
          });
        });
      }
    }
  }

  showSnackBar($event: any) {
    console.log('showSnackBar ===> ', $event);
    this._snackBar.open($event, '', {
      duration: 3000
    });
  }
  sessionExhausted($event: any) {
    console.log('limitExhausted ===> ', $event);
    this._dialog.open(DetectionLimitExhaustModalComponent, {
      backdropClass: 'custom-dialog-background',
      width: '490px',
      height: 'auto',
      scrollStrategy: new NoopScrollStrategy(),
      panelClass: "border-radius16",
    });
  }
  openFeedbackModal($event: any) {
    console.log('openFeedbackModal ===> ', $event);
    const dialogRef = this._dialog.open(FeedbackModalComponent, {
      width: '464px',
      height: 'auto',
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        feature: 'multilingual',
        language: this.editorConfig.lang
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed', result);
    });
  }
  observer!: MutationObserver;
  ngAfterViewInit() {
    this.observer = new MutationObserver(() => {
      const buttons = document.querySelectorAll('button span');
  
      buttons.forEach((el: any) => {
        if (el.textContent?.trim() === 'Check') {
          el.textContent = 'Check Grammar';
        }
      });
    });
  
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      const radioGroup = document.querySelector(
        'lib-multilingual-editor-marketing mat-radio-group'
      );
  
      if (radioGroup) {
        radioGroup.setAttribute('aria-label', 'Select language');
      }
    });

    const ul = document.querySelector('lib-multilingual-editor-marketing .degreeChange ul');

    if (ul && ul.children.length === 1) {
      const li = ul.querySelector('li');

      if (li) {
        while (li.firstChild) {
          ul.parentNode?.insertBefore(li.firstChild, ul);
        }

        ul.remove();
      }
    }

    setTimeout(() => {
      const h3 = document.querySelector(
        'lib-multilingual-editor-marketing .card-header h3'
      );
  
      if (h3 && h3.textContent?.trim() === 'Original Text') {
        const h2 = document.createElement('h2');
  
        // Copy attributes
        Array.from(h3.attributes).forEach(attr =>
          h2.setAttribute(attr.name, attr.value)
        );
  
        h2.innerHTML = h3.innerHTML;
  
        h3.parentNode?.replaceChild(h2, h3);
      }
    });
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

}
